export enum ItemKinds {
	SceneFile = "SceneFile",
	Object = "Object",
	Material = "Material",
	Scene = "Scene",
	Replace = "Replace",
	Reprocess = "Reprocess",
}
